








































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel3,batchSettings,logoutPanel,selectClassPanel,addClassPanel,counter } from "@/components";
import { TbGoods, TbGoodsClass } from '@/http';
import calculate from '@/common/util/calculate';
import { Toast } from 'vant';
import { TbStocktaking } from '@/http/api_TbStocktaking';
@Component({
    components: {
        padHeadPanel3,batchSettings,logoutPanel,selectClassPanel,addClassPanel,counter
    },
})
export default class fullInventoryDetail extends Vue {
    public $refs: {
    };


    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    totalStock=0;

    /**查询项 */
    searchValue = {
        skip:0,
        count:10,
    }

    active=1;

    baseInfo:any = {};

    get getStocktakingResult(){
        let str = "";
        switch (this.baseInfo.stocktakingResult) {
            case 1:
                str = "无盈亏"
                break;
            case 2:
                str = "有盈亏"
                break;
            case 3:
                str = "有盈亏"
                break;
            case 4:
                str = "有盈亏"
                break;
        
            default:
                break;
        }
        return str;
    }
    created() {
        this.baseInfo=JSON.parse(localStorage.getItem('fullInventoryDetail'));
    }
    async mounted() {
       
    }
    beforeDestroy() {
        localStorage.removeItem('fullInventoryDetail');   
    }
    

    /**提示弹窗 */
    async tipConfirm(){
        switch (this.tipType) {
          
        
            default:
                break;
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }

    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.searchValue.skip=0;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            
            let s = this.searchValue.count;
            let res = await TbStocktaking.GetTbStocktakingDetailList(Object.assign({},this.searchValue,{
                stocktakingId:this.baseInfo.id,
                stocktakingType:this.active,
            }))
            this.list = this.searchValue.skip==0? res.items:this.list.concat(res.items);
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            if (this.list.length >= this.total) {
            this.finished = true;
            console.log('list',this.list);
            
            }
    }
  
    /**获取商品列表 */
    async getList(){
        this.onRefresh();
    }
    /**重置 */
    resetSearch(){
        this.searchValue={
            name:"",
            goodsClassId:"",
            skip:0,
            count:10,
        }
        this.getList();
    }
    chooseTab(val){
        this.active = val;
        this.getList();
    }
    

   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/stock/fullInventoryDetail.vue